/**
 * @deprecated use the values from {@link ApiUrl} instead
 */
export enum ApiProductType {
    EDGE = 'edges',
    CORNER_RADIUS = 'radii',
    DIAGONAL_CORNERS = 'diagonal-corners',
    CUTOUT_LABOR = 'cutout-labor',
    OPTIONAL_ITEMS = 'optional-items',
    WATERFALL_LABOR = 'waterfall-labor',
}
